module.exports = __webpack_public_path__ + "img/appareil.1960bdfb.jpg";